var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBankDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 155,
    viewBox: "0 0 250 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M168.429 153.974H103.272C100.326 153.974 97.916 151.564 97.916 148.618V5.356C97.916 2.4102 100.326 0 103.272 0H168.429C171.375 0 173.785 2.4102 173.785 5.356V148.618C173.785 151.564 171.375 153.974 168.429 153.974Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M167.141 10.5146H104.562V143.456H167.141V10.5146Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M137.564 151.19C139.103 151.19 140.35 149.943 140.35 148.405C140.35 146.867 139.103 145.62 137.564 145.62C136.026 145.62 134.779 146.867 134.779 148.405C134.779 149.943 136.026 151.19 137.564 151.19Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M129.17 5.71973H144.099",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M146.635 6.46798H146.49C146.117 6.46798 145.812 6.16314 145.812 5.7909V5.64584C145.812 5.27315 146.117 4.96875 146.49 4.96875H146.635C147.007 4.96875 147.312 5.27359 147.312 5.64584V5.7909C147.312 6.16314 147.007 6.46798 146.635 6.46798Z",
    fill: "#FD6202"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M107.565 153.974H36.6836C36.6836 153.974 39.3009 138.514 54.9355 141.852C60.5227 143.044 58.7485 118.116 74.1738 119.93C85.0884 121.215 82.2957 140.668 90.4177 142.914C98.54 145.161 105.876 146.544 107.565 153.974Z",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M221.99 153.975C220.301 146.544 218.679 119.659 206.652 117.28C193.265 114.633 192.939 131.637 182.024 130.353C166.599 128.539 172.846 146.426 167.14 146.145C156.421 145.619 151.633 153.975 151.633 153.975H221.99Z",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M176.449 153.927L186.591 112.743C187.285 109.922 189.966 108.055 192.853 108.381C195.903 108.725 198.153 111.392 197.977 114.457L195.595 154L176.449 153.927Z",
    fill: "white",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M193.508 108.493L185.422 153.96",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M185.461 117.333C185.461 117.333 187.232 125.653 189.929 128.254",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M196.997 130.735C196.997 130.735 192.18 138.61 188.305 138.178",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M180.43 137.766C180.43 137.766 182.548 146.143 186.426 147.97",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M197.759 112.54C197.759 112.54 194.607 119.811 191.637 118.86",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M147.756 142.633L155.43 111.47C155.955 109.335 157.984 107.922 160.168 108.168C162.476 108.429 164.178 110.447 164.046 112.766L162.243 142.688",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M159.788 111.316L154.547 142.658",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M155.693 117.678C155.693 117.678 155.803 120.968 157.844 122.936",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M161.721 127.207C161.721 127.207 159.659 131.042 156.727 130.715",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M151.693 133.529C151.693 133.529 152.37 136.743 155.304 138.125",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M162.293 113.881C162.293 113.881 161.496 116.819 159.248 116.099",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M199.585 153.976C199.585 153.976 198.588 143.489 203.488 143.455C207.391 143.428 209.343 151.444 209.343 151.444C209.343 151.444 212.465 149.254 215.431 150.402C218.368 151.54 218.71 153.976 218.71 153.976H199.585Z",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M202.666 143.572L205.674 153.976",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M208.125 147.969L204.781 150.891",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M200.27 146.283L203.692 147.115",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M107.648 142.609C107.648 142.609 106.65 132.123 111.551 132.089C115.453 132.062 117.405 140.077 117.405 140.077C117.405 140.077 120.528 137.888 123.494 139.036C126.431 140.173 126.772 142.609 126.772 142.609",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M111.395 134.509L113.736 142.609",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M90.7547 153.974L86.3856 120.332C86.0861 118.027 84.1231 116.303 81.7995 116.303C79.3442 116.303 77.3174 118.221 77.1817 120.672L75.3438 153.973H90.7547V153.974Z",
    fill: "white",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M81.7988 116.303L83.66 153.973",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M87.0437 125.403C87.0437 125.403 84.8674 130.264 82.4902 132.09",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M76.4141 134.588C76.4141 134.588 79.625 140.39 82.7435 140.394",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M89.2153 142.123C89.2153 142.123 86.6056 147.24 83.3594 148.344",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M77.3535 119.655C77.3535 119.655 79.6548 125.283 82.1007 124.793",
    stroke: "#FD6202",
    strokeWidth: 1.2641,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M149.078 112.187H122.663C119.717 112.187 117.307 109.777 117.307 106.831V105.441C117.307 102.495 119.717 100.085 122.663 100.085H149.078C152.024 100.085 154.434 102.495 154.434 105.441V106.831C154.434 109.777 152.024 112.187 149.078 112.187Z",
    fill: "#DB4800"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M145.455 81.0568L82.8409 94.3834C79.9598 94.9967 77.1006 93.1408 76.4873 90.2597L68.2324 51.4761C67.6191 48.595 69.475 45.7358 72.3561 45.1225L134.97 31.7959C137.851 31.1826 140.71 33.0385 141.323 35.9195L149.578 74.7032C150.192 77.5843 148.336 80.4435 145.455 81.0568Z",
    fill: "#E1F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M144.338 50.0627L71.2461 65.6211L73.4796 76.1138L146.571 60.5554L144.338 50.0627Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M83.3854 58.2568L78.1379 59.3735C76.6895 59.682 75.2657 58.7576 74.9573 57.3093L73.8406 52.0617C73.5322 50.6134 74.4565 49.1896 75.9049 48.8811L81.1524 47.7644C82.6008 47.456 84.0246 48.3804 84.333 49.8287L85.4497 55.0762C85.7581 56.5246 84.8338 57.9484 83.3854 58.2568Z",
    fill: "#DB4800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M138.971 65.8903L89.9766 76.3193L90.3061 77.8674L139.301 67.4383L138.971 65.8903Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M139.631 68.9938L90.6367 79.4229L90.9662 80.9709L139.961 70.5418L139.631 68.9938Z",
    fill: "#FD6202"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M249.954 153.974H0.0449219",
    stroke: "#FD6202",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M167.139 10.5186H104.561V19.0895H167.139V10.5186Z",
    fill: "#E1F0FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M127.895 142.665C127.895 142.665 130.133 123.106 125.71 123.114C122.67 123.12 122.223 134.251 122.223 134.251C122.223 134.251 121.016 131.199 118.57 131.112C116.696 131.045 115.354 132.885 115.354 132.885",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M125.658 124.832C125.658 124.832 124.981 132.89 124.721 138.154",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M138.714 142.132C138.714 142.132 137.992 135.075 140.616 134.031C143.426 132.914 145.716 136.872 145.716 136.872C145.716 136.872 144.051 127.605 146.444 126.343C148.838 125.081 150.295 127.416 150.295 127.416",
    stroke: "white",
    strokeWidth: 1.0757,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBankDetails);
export default __webpack_public_path__ + "static/media/emptyBankDetails.15b37909b55c608134cd1fb668badaf2.svg";
export { ForwardRef as ReactComponent };